import { GameMainTransitionProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameMainTransitionProperties";
export class GameMainTransitionLandscapeProperties extends GameMainTransitionProperties {
    setDefaultValues() {
        super.setDefaultValues();
    }
}
